<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(parte, index) in partes"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <ParteTransporte :parte="parte" />
        </b-col>

        <!-- Remove Button -->
        <b-col v-if="partes.length > 1" cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="secondary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar parte transporte</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import ParteTransporte from '@/views/CartaPorte/ParteTransporte'

export default {
  components: {
    ParteTransporte,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    partes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      nextRowId: 0,
    }
  },
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.partes.length
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    this.addItem()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    addItem() {
      this.partes.push({
        '@ParteTransporte': { title: 'PT01 - Camión unitario', value: 'PT01' },
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      if (this.partes.length > 1) {
        this.partes.splice(index, 1)
        this.trTrimHeight(this.$refs.row[0].offsetHeight)
      }
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
